import * as t from "io-ts"

export const PublishLCTAmendmentResponse = t.type({
    published_device_id: t.string,
    amendment_ref: t.string,
})

export type TPublishLCTAmendmentResponse = t.TypeOf<
    typeof PublishLCTAmendmentResponse
>

export const PublishLCTDeviceResponse = t.type({
    deviceRef: t.string,
})

export type TPublishLCTDeviceResponse = t.TypeOf<
    typeof PublishLCTDeviceResponse
>

export type TPublishLCTDevicePostResponse = t.TypeOf<
    typeof PublishLCTDevicePostResponse
>

export const PublishLCTDevicePostResponse = t.type({
    SystemReference: t.string,
})
